import React, { useContext } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import PrimaryButton from '../../Components/Button/PrimaryButton'
import { AuthContext } from '../../contexts/AuthProvider'
import toast from 'react-hot-toast'
import SmallSpinner from '../../Components/Spinner/SmallSpinner'
import { setAuthToken } from '../../api/auth'

const Signup = () => {
  const {
    createUser,
    updateUserProfile,
    verifyEmail,
    loading,
    setLoading,
    signInWithGoogle,
  } = useContext(AuthContext)

  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname || '/'

  const handleSubmit = event => {
    event.preventDefault()
    const name = event.target.name.value
    const email = event.target.email.value
    const password = event.target.password.value

    // Create User
    createUser(email, password)
      .then(result => {
        setAuthToken(result.user)
        updateUserProfile(name)
          .then(
            verifyEmail().then(() => {
              toast.success('Sign up successfully.')
              setLoading(false)
              navigate(from, { replace: true })
            })
          )
          .catch(err => console.log(err))
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      })
  }

  const handleGoogleSignin = () => {
    signInWithGoogle().then(result => {
      console.log(result.user)
      setAuthToken(result.user)
      setLoading(false)
      navigate(from, { replace: true })
    })
  }

  return (
    <div className='flex justify-center items-center min-h-screen bg-gray-100 w-full'>
    <div className='flex flex-col w-full max-w-md p-8 rounded-lg shadow-xl bg-white text-gray-900'>
      <div className='mb-10 text-center'>
        <h1 className='text-3xl font-bold font-raleway text-gray-900'>Create Account</h1>
        <p className='mt-2 text-gray-500'>
          Join us to get started
        </p>
      </div>
      <form
        onSubmit={handleSubmit}
        className='space-y-6'
      >
        <div className='space-y-5'>
          <div>
            <label htmlFor='name' className='block mb-2 text-sm font-medium text-gray-700'>
              Full Name
            </label>
            <input
              type='text'
              name='name'
              id='name'
              required
              placeholder='Enter your full name'
              className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white text-gray-900 placeholder-gray-400'
            />
          </div>
          <div>
            <label htmlFor='email' className='block mb-2 text-sm font-medium text-gray-700'>
              Email address
            </label>
            <input
              type='email'
              name='email'
              id='email'
              required
              placeholder='Enter your email'
              className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white text-gray-900 placeholder-gray-400'
            />
          </div>
          <div>
            <label htmlFor='password' className='block mb-2 text-sm font-medium text-gray-700'>
              Password
            </label>
            <input
              type='password'
              name='password'
              id='password'
              required
              placeholder='Create a password'
              className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white text-gray-900 placeholder-gray-400'
            />
          </div>
        </div>
  
        <div>
          <PrimaryButton
            type='submit'
            classes='w-full px-6 py-3.5 text-sm font-semibold rounded-lg bg-gray-900 hover:bg-gray-800 text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900'
          >
            {loading ? <SmallSpinner /> : 'Sign Up'}
          </PrimaryButton>
        </div>
      </form>
  
      <div className='mt-6 text-center'>
        <p className='text-sm text-gray-500'>
          Already have an account?{' '}
          <Link 
            to='/login' 
            className='font-medium text-gray-900 hover:text-gray-700 transition-colors'
          >
            Sign In
          </Link>
        </p>
      </div>
  
      {/* Social login section (commented out as in original) */}
      {/* <div className='mt-8'>
        <div className='relative'>
          <div className='absolute inset-0 flex items-center'>
            <div className='w-full border-t border-gray-300'></div>
          </div>
          <div className='relative flex justify-center text-sm'>
            <span className='px-2 bg-white text-gray-500'>
              Or sign up with
            </span>
          </div>
        </div>
  
        <div className='mt-6 grid grid-cols-3 gap-3'>
          <button className='w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50'>
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12.545 10.239v3.821h5.445c-0.712 2.315-2.647 3.972-5.445 3.972-3.332 0-6.033-2.701-6.033-6.032s2.701-6.032 6.033-6.032c1.498 0 2.866 0.549 3.921 1.453l2.814-2.814c-1.784-1.612-4.145-2.589-6.735-2.589-5.522 0-10 4.477-10 10s4.478 10 10 10c8.396 0 10-5.373 10-10 0-0.61-0.061-1.076-0.144-1.527z"/>
            </svg>
          </button>
          <button className='w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50'>
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M22.46 6c-0.77 0.35-1.6 0.58-2.46 0.69 0.88-0.53 1.56-1.37 1.88-2.38-0.83 0.5-1.75 0.85-2.72 1.03-0.78-0.83-1.89-1.34-3.11-1.34-2.35 0-4.27 1.92-4.27 4.29 0 0.34 0.04 0.67 0.11 0.98-3.54-0.18-6.73-1.89-8.84-4.48-0.37 0.63-0.58 1.37-0.58 2.15 0 1.49 0.75 2.81 1.91 3.56-0.71 0-1.37-0.2-1.95-0.5v0.05c0 2.08 1.48 3.82 3.44 4.21-0.36 0.1-0.74 0.15-1.13 0.15-0.27 0-0.54-0.03-0.8-0.08 0.54 1.69 2.11 2.92 3.97 2.92-1.45 1.16-3.29 1.86-5.29 1.86-0.34 0-0.68-0.02-1.02-0.06 1.89 1.22 4.13 1.93 6.54 1.93 7.87 0 12.16-6.55 12.16-12.16 0-0.18 0-0.36-0.01-0.54 0.84-0.61 1.56-1.36 2.14-2.23z"/>
            </svg>
          </button>
          <button className='w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50'>
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0.296c-6.627 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.385 0.6 0.113 0.82-0.258 0.82-0.577 0-0.285-0.01-1.04-0.015-2.04-3.338 0.724-4.042-1.61-4.042-1.61-0.546-1.385-1.335-1.755-1.335-1.755-1.087-0.744 0.084-0.729 0.084-0.729 1.205 0.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495 0.998 0.108-0.776 0.417-1.305 0.76-1.605-2.665-0.3-5.466-1.332-5.466-5.93 0-1.31 0.465-2.38 1.235-3.22-0.135-0.303-0.54-1.523 0.105-3.176 0 0 1.005-0.322 3.3 1.23 0.96-0.267 1.98-0.399 3-0.405 1.02 0.006 2.04 0.138 3 0.405 2.28-1.552 3.285-1.23 3.285-1.23 0.645 1.653 0.24 2.873 0.12 3.176 0.765 0.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92 0.42 0.36 0.81 1.096 0.81 2.22 0 1.606-0.015 2.896-0.015 3.286 0 0.315 0.21 0.69 0.825 0.57 4.801-1.574 8.236-6.074 8.236-11.369 0-6.627-5.373-12-12-12z"/>
            </svg>
          </button>
        </div>
      </div> */}
    </div>
  </div>
  )
}

export default Signup
